import React from 'react';

import { WanderingBoundaryRowProviderState } from 'features/wandering-boundary-settings/providers/states/wandering-boundary-row-provider-state';

const WanderingBoundaryRowProviderContext = React.createContext<WanderingBoundaryRowProviderState>({} as never);

export default WanderingBoundaryRowProviderContext;
